  
     
      <div class="row">

        <div class="col-12 col-sm-6 col-md-3">
          <div class="info-box" [ngClass]="{'dark-bg' : isDark }">
            <span class="info-box-icon bg-info elevation-1"><i class="fa fa-line-chart text-white"></i></span>  
            <div class="info-box-content chart-font-size">
              <span class="info-box-text">Sales</span>
              <span class="info-box-number">
               {{currentMonthSales  |  number:'1.2-2'}}                     
              </span>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-3">
          <div class="info-box mb-3" [ngClass]="{'dark-bg' : isDark }">
            <span class="info-box-icon bg-warning elevation-1"><i class="fas fa-dolly text-white"></i></span>   
            <div class="info-box-content chart-font-size">
              <span class="info-box-text">Purchases</span>
              <span class="info-box-number">{{ currentMonthPurchases |  number:'1.2-2'}}</span>
            </div>
          </div>
        </div>


        <div class="col-12 col-sm-6 col-md-3">
          <div class="info-box mb-3" [ngClass]="{'dark-bg' : isDark }">
            <span class="info-box-icon bg-success elevation-1"><i class="fa fa-bar-chart text-white"></i></span>    
            <div class="info-box-content chart-font-size">
              <span class="info-box-text">Gross Profit</span>
              <span class="info-box-number">{{ currentMonthProfit |  number:'1.2-2'}}</span>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-3">
          <div class="info-box mb-3" [ngClass]="{'dark-bg' : isDark }">
            <span class="info-box-icon bg-danger elevation-1"><i class="fa fa-pie-chart text-white"></i></span>   
            <div class="info-box-content chart-font-size">
              <span class="info-box-text">Expenses</span>
              <span class="info-box-number">{{currentMonthExpenses |  number:'1.2-2'}}</span>
            </div>
          </div>
        </div>

   
  </div>

  <div class="row">
    <!-- Sales Chart -->
   <div class="col-12 col-md-6">
      <nb-card>
        <nb-card-header class="text-center">Annual Sales</nb-card-header>
       <nb-card-body>
         <canvas baseChart  height="150"
           [datasets]="lineChartData"
           [labels]="lineChartLabels"
           [options]="lineChartOptions"
           [legend]="lineChartLgend"
           [chartType]="lineChartType">                    
        </canvas>
      </nb-card-body>
      </nb-card>
   </div>

   <!-- collections and Commissions Chart -->


   <div class="col-12 col-md-6">
    <nb-card>
      <nb-card-header class="text-center chart-font-size">Annual Sales & Profit</nb-card-header>
      <nb-card-body>
          <canvas baseChart height="150"
            [datasets]="profitChartData"
            [labels]="profitChartLabels"
            [options]="profitChartOptions"
            [legend]="profitChartLgend"
            [chartType]="profitChartType">                      
          </canvas>
        </nb-card-body>
    </nb-card>
   </div>


 </div>

 <div class="row">
  <!-- Sales Chart -->
  <div class="col-12 col-md-6">
    <nb-card>
      <nb-card-header class="text-center chart-font-size">Invoice Analysis - {{month}}</nb-card-header>
     <nb-card-body>
       <canvas baseChart height="193"
         [data]="pieChartData"
         [labels]="pieChartLabels"
         [chartType]="pieChartType"
         [colors]=" pieChartColors">                        
       </canvas>
      </nb-card-body>
     <!-- /.card-body -->
    </nb-card>    
</div>

    <!-- DONUT CHART -->
 <div class="col-12 col-md-6">
  <nb-card>

    <div class="info-box mb-3 bg-success">
      <span class="info-box-icon"><i class="fas fa-users text-white"></i></span>
      <div class="info-box-content">
        <span class="info-box-text text-white">Customer Outstanding</span>
        <span class="info-box-number text-white">{{customerOutstanding |  number:'1.2-2'}}</span>
      </div>
    </div>

    <div class="info-box mb-3 bg-danger">
      <span class="info-box-icon"><i class="fa fa-credit-card text-white"></i></span>
      <div class="info-box-content">
        <span class="info-box-text text-white">Supplier Outstanding</span>
        <span class="info-box-number text-white">{{supplierOutstanding |  number:'1.2-2'}}</span>
      </div>
    </div>

    
    <div class="info-box mb-3 bg-info">
      <span class="info-box-icon"><i class="fa fa-money text-white"></i></span>
      <div class="info-box-content">
        <span class="info-box-text text-white">Invoice Count</span>
        <span class="info-box-number text-white">{{invoiceCount}}</span>
      </div>
    </div>

    <!-- <div class="info-box mb-3 bg-warning">
      <span class="info-box-icon"><i class="fa fa-shopping-cart text-white"></i></span>
      <div class="info-box-content">
        <div class="row">
        <div class="col-6">
          <span class="info-box-text text-white">Open Orders</span>
          <span class="info-box-number text-white">{{openOrders}}</span>
        </div>
        <div class="col-6">
          <span class="info-box-text text-white">Processing Orders</span>
          <span class="info-box-number text-white">{{processingOrders}}</span>
        </div>
      </div>
      </div>
    </div> -->


  </nb-card>         
 </div>

</div>

 

